Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var components_baseButton_Component = require('../components/base-button/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var defaultColors = {"primary":"button__primary_4zf8j","loader":"button__loader_4zf8j","secondary":"button__secondary_4zf8j","text":"button__text_4zf8j","ghost":"button__ghost_4zf8j","component":"button__component_4zf8j","loading":"button__loading_4zf8j","outlined":"button__outlined_4zf8j","tertiary":"button__tertiary_4zf8j","transparent":"button__transparent_4zf8j","link":"button__link_4zf8j"};
require('./default.mobile.css');

var invertedColors = {"primary":"button__primary_1dp5a","loader":"button__loader_1dp5a","secondary":"button__secondary_1dp5a","text":"button__text_1dp5a","ghost":"button__ghost_1dp5a","component":"button__component_1dp5a","loading":"button__loading_1dp5a","outlined":"button__outlined_1dp5a","tertiary":"button__tertiary_1dp5a","transparent":"button__transparent_1dp5a","link":"button__link_1dp5a"};
require('./inverted.mobile.css');

var styles = {"size-32":"button__size-32_k37nv","size-40":"button__size-40_k37nv","size-48":"button__size-48_k37nv","size-56":"button__size-56_k37nv","size-64":"button__size-64_k37nv","size-72":"button__size-72_k37nv"};
require('./mobile.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = React.forwardRef(function (restProps, ref) { return (React__default.default.createElement(components_baseButton_Component.BaseButton, tslib.__assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

exports.ButtonMobile = ButtonMobile;
